
import { Typewriter } from 'react-simple-typewriter';
import { MiniContainer } from '../../Components';
import { ProjectsSec } from '../../Sections';

import './ProjectsPage.css';



const ProjectsPage = () => {
    return (
        <div className="projects-page">
            <h1 className="pageTitle mb-4">
                <Typewriter
                    words={["A selection of our projects"]}
                    loop={1}
                    cursor
                    cursorStyle="|"
                    typeSpeed={70}
                    deleteSpeed={0}
                    delaySpeed={1500}
                />
            </h1>
            <MiniContainer>
                <ProjectsSec />
            </MiniContainer>
        </div>
    );
};

export default ProjectsPage;
